<ng-container *ngIf="isOpen$ | async as open">
  <div class="drawer-backdrop" [class.is-open]="open" (click)="close()"></div>
</ng-container>

<aside class="drawer" [class.is-open]="isOpen$ | async">
  <header class="drawer__header">
    <img src="assets/image/redesign/CHEZ-CHOUX-logo.png" alt="西樹泡芙" class="drawer__logo">
    <button class="drawer__close" i18n-aria-label="@@drawer.close.aria" aria-label="Close menu" (click)="close()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
        <path d="M18 6 6 18M6 6l12 12"/>
      </svg>
    </button>
  </header>

  <nav class="drawer__links">
    <a *ngFor="let link of links" [href]="link.href" class="drawer__link" (click)="close()">{{ link.label }}</a>
  </nav>

  <footer class="drawer__footer">
    <a href="tel:+85226901853" class="drawer__footer-item">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
      <span i18n="@@drawer.phone">+(852) 2690 1853</span>
    </a>
  </footer>
</aside>
